import { configureStore } from '@reduxjs/toolkit';
import { 
  persistStore, 
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';

// ... (other imports)
import storage from 'redux-persist/lib/storage';
import { combineReducers } from 'redux';
import loginReducer from './login';
import dashboardMenuReducer from './dashboardMenu';
import saveReducer from './saveSlice';
import researchReducer from './researchSlice';
import jobCenterReducer from './jobCenterSlice';
import studentsReducer from './studentsSlice';
import consultantsReducer from './consultantsSlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['loginUserData', 'dashboardMenuData', 'saveStatus', 'researchData', 'jobCenterData', 'studentsData', 'consultantsData'], // The reducers you want to persist
};

const rootReducer = combineReducers({
  loginUserData: loginReducer,
  dashboardMenuData: dashboardMenuReducer,
  saveStatus: saveReducer,
  researchData: researchReducer,
  jobCenterData: jobCenterReducer,
  studentsData: studentsReducer,
  consultantsData: consultantsReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
